import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Panel } from "../components/Surface";
import { Button } from "../components/ui/Button";
import { listCommunities, joinCommunity, type Community } from "../lib/communities";

export function Communities() {
  const [items, setItems] = useState<Community[]>([]);
  const [busy, setBusy] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    setItems((await listCommunities()).communities);
  }
  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, []);

  async function join(c: Community) {
    setBusy(c.id);
    try {
      await joinCommunity(c.id);
      await refresh();
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-6">
      <PageHeader title="Communities" subtitle="Join groups to talk shop with other trucking professionals." />
      {loading ? (
        <p className="font-mono text-sm text-muted">Loading…</p>
      ) : (
        <div className="grid gap-3">
          {items.map((c) => (
            <Panel key={c.id}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <Link to={`/communities/${c.slug}`} className="font-display text-lg font-black tracking-tight hover:text-accent-strong">{c.name}</Link>
                  {c.description && <p className="text-sm text-muted">{c.description}</p>}
                  <p className="font-mono text-[11px] text-muted">{c.member_count} member{c.member_count === 1 ? "" : "s"}</p>
                </div>
                {c.joined ? (
                  <Link to={`/communities/${c.slug}`}><span className="font-mono text-xs font-bold text-verified">Joined ✓</span></Link>
                ) : (
                  <Button variant="ghost" disabled={busy === c.id} onClick={() => join(c)}>{busy === c.id ? "…" : "Join"}</Button>
                )}
              </div>
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
}
